import React from 'react';
import Tooltip from '../components/tooltip/Tooltip';
import { Badge, Form } from 'react-bootstrap';
import { NewTabBadge } from '../components/badge/NewTabBadge';

const renderUtils = {
  renderMachineType: (machine) => {
    return machineTypes[machine.machineType]
      ? machineTypes[machine.machineType]
      : machine.machineType;
  },

  renderMachine: (machine) => {
    return [machine.model, machine.serialNumber]
      .filter((item) => item && item.trim() !== '') // Filter out empty or blank strings
      .join(' '); // Join the remaining strings with a
  },

  renderOperatingParameterTemplate: (template) => {
    return [template.name, template.value]
      .filter((item) => item && item.trim() !== '') // Filter out empty or blank strings
      .join(' '); // Join the remaining strings with a
  },
  renderEnumName: (enumValue, enumType) => {
    if (renderConfig[enumType]) {
      const result = renderConfig[enumType][enumValue];

      return result || enumValue;
    } else {
      return enumValue;
    }
  },
  renderEventName: (event) => {
    return (
      event.title &&
      renderUtils.renderEnumName(event.title, 'enums/businessEventType')
    );
  },
  renderPaymentModel: (model) => {
    return renderUtils.renderEnumName(model, 'enums/paymentModel');
  },
  formatDate: (dateStr, year) => {
    if (!dateStr) return dateStr;

    return new Date(dateStr).toLocaleDateString('pl-PL', {
      weekday: 'short', // <-- dodane
      day: '2-digit',
      month: 'short',
      ...(year && { year: 'numeric' })
    });
  },
  formatDateWithTime: (dateStr) => {
    if (!dateStr) return null;

    const date = new Date(dateStr);
    if (isNaN(date)) return null;

    const datePart = date.toLocaleDateString('pl-PL', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    const timePart = date.toLocaleTimeString('pl-PL', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    return `${datePart} : ${timePart}`;
  },
  renderEvent: (event, withDate) => {
    return (
      <div className={'d-flex'}>
        <Tooltip tooltip={'Wydarzenie z dnia ' + event.creationDate}>
          <Badge className={'bg-light text-dark font-max mr-1'}>
            {renderUtils.renderEventName(event)}
          </Badge>
        </Tooltip>
        <NewTabBadge
          tooltip={'Więcej o komplecie'}
          placement={'bottom'}
          sameTabUtl={'/toolset/details/' + event.toolSetId}
          className={'ms-1'}
        >
          {event.toolSetId}
        </NewTabBadge>
        {withDate && (
          <Tooltip tooltip={'Data wydarzenia'}>
            <Badge className={'bg-light text-dark font-max mr-1'}>
              {event.creationDate}
            </Badge>
          </Tooltip>
        )}
      </div>
    );
  },
  getNightLabel: (count) => {
    if (count === 1) return 'noc';
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100))
      return 'noce';
    return 'nocy';
  },
  getGuestLabel: (count) => {
    if (count === 1) return 'gość';
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100))
      return 'goście';
    return 'gości';
  },

  renderStatus: (status, className, disableTopMargin) => {
    const defaultClassName = 'font-max ' + (disableTopMargin ? '' : 'mt-2');
    const statusInfo = statusMapping[status];
    return statusInfo ? (
      <span
        className={`${statusInfo.className} ${defaultClassName} ${className}`}
      >
        {statusInfo.label}
      </span>
    ) : (
      'Niewiadomy status'
    );
  },

  renderOrderStatus: (status, className, disableTopMargin) => {
    const defaultClassName = 'font-max ' + (disableTopMargin ? '' : 'mt-2');
    const statusInfo = orderStatusMapping[status];
    return statusInfo ? (
      <span
        className={`${statusInfo.className} ${defaultClassName} ${className}`}
      >
        {statusInfo.label}
      </span>
    ) : (
      'Niewiadomy status'
    );
  },

  renderPartStatus: (status, className, disableTopMargin) => {
    const defaultClassName = 'font-max ' + (disableTopMargin ? '' : 'mt-2');
    const statusInfo = partStatusMapping[status];
    return statusInfo ? (
      <span
        className={`${statusInfo.className} ${defaultClassName} ${className}`}
      >
        {statusInfo.label}
      </span>
    ) : (
      'Niewiadomy status'
    );
  },
  renderAlarmStatus: (status, count) => {
    console.log('count: ', count);
    const defaultClassName = 'font-max mr-2';

    const statusInfo = alarmStatus[status];
    return statusInfo ? (
      <span
        className={`${statusInfo.className} ${defaultClassName}`}
      >{`${statusInfo.label}${count ? ` (${count})` : ''}`}</span>
    ) : (
      'Niewiadomy status'
    );
  },
  renderTaskStatus: (status, count) => {
    console.log('count: ', count);
    const defaultClassName = 'font-max ms-2';

    const statusInfo = taskStatus[status];
    return statusInfo ? (
      <span
        className={`${statusInfo.className} ${defaultClassName}`}
      >{`${statusInfo.label}${count ? ` (${count})` : ''}`}</span>
    ) : (
      'Niewiadomy status'
    );
  },

  renderAlarmDate: (status, date) => {
    const defaultClassName = 'font-max mr-2';

    const statusInfo = alarmStatus[status];
    return (
      <Tooltip tooltip={'Data utworzenia'}>
        <span className={`${statusInfo.className} ${defaultClassName} `}>
          {date}
        </span>
      </Tooltip>
    );
  },
  renderTaskDate: (status, date) => {
    const defaultClassName = 'font-max mr-2';

    const statusInfo = taskStatus[status];
    return (
      <Tooltip tooltip={'Data utworzenia zadania'}>
        <span className={`${statusInfo.className} ${defaultClassName} `}>
          {date}
        </span>
      </Tooltip>
    );
  },
  renderEventDate: (read, date) => {
    const defaultClassName = 'font-max me-2';

    const statusInfo = eventStatus[read ? 'READ' : 'NOT_READ'];
    return (
      <Tooltip tooltip={'Data utworzenia wydarzenia'}>
        <span className={`${statusInfo.className} ${defaultClassName} `}>
          {date}
        </span>
      </Tooltip>
    );
  },
  renderAlarmStatusButton: (status, onClick) => {
    const defaultClassName = 'font-max';
    const statusInfo = alarmStatusButton[status];
    return statusInfo ? (
      <Tooltip tooltip={statusInfo.label}>
        <span
          onClick={() => onClick(statusInfo.toStatus)}
          className={`ml-1 cursor-pointer ${statusInfo.className} ${defaultClassName}`}
        >
          <i className={'fas ' + statusInfo.icon}></i>
        </span>
      </Tooltip>
    ) : (
      ''
    );
  },
  renderTaskStatusButton: (status, onClick) => {
    const defaultClassName = 'font-max';
    const statusInfo = taskStatusButton[status];
    return statusInfo ? (
      <Tooltip tooltip={statusInfo.label}>
        <span
          onClick={() => onClick(statusInfo.toStatus)}
          className={`ms-1 cursor-pointer ${statusInfo.className} ${defaultClassName}`}
        >
          <i className={'fas ' + statusInfo.icon}></i>
        </span>
      </Tooltip>
    ) : (
      ''
    );
  },
  renderEventReadButton: (id, read, onClick) => {
    return (
      <Tooltip
        tooltip={
          read ? 'Oznacz jako nieprzeczytane' : 'Oznacz jako przeczytane'
        }
      >
        <Form.Check // prettier-ignore
          type={'checkbox'}
          checked={read}
          id={`default-` + id}
          onClick={onClick}
        />
      </Tooltip>
    );
  }
};
const statusMapping = {
  CREATED: {
    label: 'Nowe',
    className: 'badge bg-secondary'
  },
  CANCELED: {
    label: 'Anulowano',
    className: 'badge bg-danger'
  }
};

const orderStatusMapping = {
  OFFER_CREATED: {
    label: 'Zapytanie ofertowe',
    className: 'badge bg-secondary'
  },
  ORDER_CREATED: { label: 'Złożono zamówienie', className: 'badge bg-primary' },
  ORDER_COMPLETED: {
    label: 'Zamówienie zrealizowane',
    className: 'badge bg-success'
  },
  CANCELED: { label: 'Anulowane', className: 'badge bg-danger' }
};

const partStatusMapping = {
  STORAGE: { label: 'W magazynie', className: 'badge badge-secondary' },
  SERVICE: { label: 'W serwisie', className: 'badge badge-warning' },
  INSTALLED: { label: 'W użyciu', className: 'badge badge-primary' },
  PRODUCTION: { label: 'Produkcja', className: 'badge badge-danger' },
  DIMENSIONING: { label: 'W zwymiarowaniu', className: 'badge badge-info' },
  WITHDRAWN: { label: 'Zutylizowany', className: 'badge badge-dark' },
  DELETED: { label: 'Usunięty', className: 'badge badge-danger' }
};
export const alarmStatus = {
  CREATED: {
    label: 'Utworzono',
    className: 'badge badge-warning',
    variant: 'warning'
  },
  IN_PROGRESS: {
    label: 'W trakcie',
    className: 'badge badge-primary',
    variant: 'primary'
  },
  DONE: {
    label: 'Zakończono',
    className: 'badge badge-success',
    variant: 'success'
  }
};

export const taskStatus = {
  CREATED: {
    label: 'Utworzono',
    className: 'badge bg-warning',
    variant: 'warning'
  },
  IN_PROGRESS: {
    label: 'W trakcie',
    className: 'badge bg-blue',
    variant: 'primary'
  },
  DONE: {
    label: 'Zakończono',
    className: 'badge bg-success',
    variant: 'success'
  }
};

export const eventStatus = {
  READ: {
    label: 'Przeczytano',
    className: 'badge bg-success',
    variant: 'success'
  },
  NOT_READ: {
    label: 'Nie przeczytano',
    className: 'badge bg-secondary',
    variant: 'light'
  }
};
export const alarmStatusButton = {
  CREATED: {
    label: 'Rozpocznij',
    icon: 'fa-play',
    className: 'badge badge-warning',
    variant: 'warning',
    toStatus: 'IN_PROGRESS'
  },
  IN_PROGRESS: {
    label: 'Zakończ',
    icon: 'fa-check',
    className: 'badge badge-primary',
    variant: 'primary',
    toStatus: 'DONE'
  }
};

export const taskStatusButton = {
  CREATED: {
    label: 'Rozpocznij',
    icon: 'fa-play',
    className: 'badge bg-warning',
    variant: 'warning',
    toStatus: 'IN_PROGRESS'
  },
  IN_PROGRESS: {
    label: 'Zakończ',
    icon: 'fa-check',
    className: 'badge bg-blue',
    variant: 'primary',
    toStatus: 'DONE'
  }
};

const machineTypes = {
  BLISTERING: 'Maszyna blistrująca',
  CARTON: 'Kartoniarka',
  CAPPER: 'Zakręcarka',
  SELECTOR: 'Selektor',
  ANTARES: 'Antares',
  VIGNETTES: 'Winietkarka',
  DATAMATRIX: 'Datamatrix',
  COMMON_CARTON: 'Zbiorcza pakowarka kartonów',
  BLOWING_MACHINE: 'Maszyna przedmuchująca',
  COUNTER_MACHINE: 'Liczarka',
  LABELLING_MACHINE: 'Etykieciarka',
  PACKAGER: 'Pakieciarka',
  SACHET_MACHINE: 'Saszetkarka',
  PERIPHERALS: 'Urządzenia peryferyjne',
  BOTTLING_MACHINE: 'Rozlewnica'
};

const renderConfig = {
  'enums/businessEventType': {
    TOOLSET_CREATION: 'Dodanie nowego kompletu',
    TOOLSET_ORDER_CREATION: 'Dodanie nowego zapytania ofertowego/zamówienia',
    PRODUCTION_START: 'Wydanie na produkcję',
    CLEANING: 'Czyszczenie',
    CONSERVATION: 'Konserwacja',
    CREATION: 'Dodanie narzędzi',
    MEASUREMENT: 'Ocena stanu technicznego',
    POLISHING: 'Polerowanie',
    PRODUCTION_END: 'Zakończenie produkcji',
    REPAIR: 'Naprawa',
    STORAGE: 'Przechowywanie',
    TOOLSET_LOCK: 'Zablokowanie kompletu',
    TOOLSET_WITHDRAWAL: 'Wycofanie kompletu',
    TOOL_WITHDRAWN: 'Wycofanie narzędzi'
  },
  'enums/matrixOrSegment': {
    MATRIX: 'Matryca',
    SEGMENT: 'Segment'
  },
  'enums/matrixInputType': {
    ONE_SIDE: 'Jednostronne',
    DOUBLE_SIDE: 'Dwustronne'
  },
  globalConfigKey: {
    CHECKIN_TIME: 'Zameldowanie',
    CHECKOUT_TIME: 'Wymeldowanie',
    PAYMENT_ON_RESERVATION_PERCENTAGE: 'Płatność przy rezerwacji'
  },
  'enums/paymentModel': {
    FULL_PAYMENT_ON_BOOKING: 'Całość płatności przy rezerwacji',
    PARTIAL_PAYMENT:
      'Częściowa płatność: zaliczka przy rezerwacji, reszta przy zameldowaniu',
    FULL_PAYMENT_ON_CHECKIN: 'Całość płatna przy zameldowaniu'
  },
  'enums/paymentType': {
    CASH: 'Gotówka',
    BANK_TRANSFER: 'Przelew bankowy',
    PAYMENT_SYSTEM: 'System płatniczy'
  },
  'enums/transactionType': {
    PAYMENT: 'Płatność',
    REFUND: 'Zwrot',
    DEPOSIT_PAYMENT: 'Wpłata kaucji',
    DEPOSIT_REFUND: 'Wypłata kaucji'
  },
  'enums/legalDocumentCode': {
    TERMS_OF_SERVICE: 'Regulamin',
    PRIVACY_POLICY: 'Polityka prywatności',
    CANCELLATION_POLICY: 'Zasady anulowania rezerwacji'
  },
  'enums/mailType': {
    RESERVATION_CREATED: 'Rezerwacja utworzona',
    RESERVATION_CONFIRMATION: 'Potwierdzenie rezerwacji',
    CHECKIN_REMINDER: 'Przypomnienie o zameldowaniu',
    RESERVATION_CANCELLED: 'Potwierdzenie anulowania',
    OTHER: 'Inny'
  },
  'enums/mailStatus': {
    SENT: 'Wysłano',
    FAILED: 'Błąd'
  }
};

export default renderUtils;
